import http, { AxiosInstance } from "axios";

export default http;
export type { AxiosInstance };
